import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";

import { FlightShopType } from "redmond";
import {
  getTripCategory,
  getDepartureDate,
  getReturnDate,
} from "../../../search/reducer";
import {
  airportsSelector,
  isOutgoingMultiTicketSelector,
  selectedTripSelector,
  tripDetailsLoadingSelector,
  tripDetailsSelector,
  selectedFareDetailsSelector,
  perPaxRefundableFarePricesSelector,
  customizeCheckoutBreakdownTotalPricesSelector,
  predictionSelector,
  getViewedTripSummaryProperties,
  isReturnMultiTicketSelector,
  getPriceDropProperties,
  cfarOfferSelector,
  fetchAncillaryOfferCallStateSelector,
  isAddOnOptionAvailableSelector,
  getOffersByTripId,
  getTravelOfferProperties,
  isInDisruptionProtectionRebookSelector,
  flightShopTypeSelector,
  hasActiveRefundableFareInFlightShopSelector,
  refundableFaresPropertiesSelector,
  getCorporateTravel,
  flightShopProductRedeemChoice,
  selectedCfarOfferSelector,
} from "../../reducer/selectors";
import {
  isCfarEnabledSelector,
  isCustomizePageMarketplaceEnabledSelector,
  batchCfarOffersCallStateSelector,
} from "../../../ancillary/reducer";
import {
  getSelectedAccount,
  getSelectedAccountReferenceIdIfRedemptionEnabled,
} from "../../../rewards/reducer";
import { FlightShopReviewItinerary } from "./component";
import { IStoreState } from "../../../../reducers/types";
import { populateFlightBookQueryParams } from "../../../book/actions/actions";
import { batchFetchCfarOffers } from "../../../ancillary/actions/actions";
import {
  setFlightShopProgress,
  setMulticityFlightShopProgress,
  fetchAncillaryOffer,
} from "../../actions/actions";
import { getTravelWalletCredit } from "../../../travel-wallet/reducer";
import {
  isCfarMulticityEnabledSelector,
} from "../../reducer/selectors/experiments";
import { getPotentialCrossSellOffers } from "../../../cross-sell/reducer/selectors";
import { hasTravelFusionInSelectedTripDetailsSelector } from "../../../book/reducer";

const mapStateToProps = (state: IStoreState) => {
  const selectedTrip = selectedTripSelector(state);
  const tripId = selectedTrip.tripId || "";
  const tripDetails = tripDetailsSelector(state, tripId);

  return {
    productRedeemChoice: flightShopProductRedeemChoice(state),
    tripCategory: getTripCategory(state),
    departureDate: getDepartureDate(state),
    returnDate: getReturnDate(state),
    airports: airportsSelector(state, tripId),
    tripDetails,
    selectedTrip,
    fareDetails: selectedFareDetailsSelector(state),
    perPaxRefundableFarePrices: perPaxRefundableFarePricesSelector(state),
    perPaxPrices: customizeCheckoutBreakdownTotalPricesSelector(state),
    tripDetailsLoading: tripDetailsLoadingSelector(state),
    isMultiTicket:
      isOutgoingMultiTicketSelector(state) ||
      isReturnMultiTicketSelector(state),
    rewardsKey: getSelectedAccountReferenceIdIfRedemptionEnabled(state),
    prediction: predictionSelector(state),
    viewedTripSummaryProperties: getViewedTripSummaryProperties(state),
    priceDropViewedProperties: getPriceDropProperties(state),
    cfarOffer: cfarOfferSelector(state),
    fetchAncillaryOfferCallState: fetchAncillaryOfferCallStateSelector(state),
    batchCfarOffersCallState: batchCfarOffersCallStateSelector(state),
    isAddOnOptionAvailable: isAddOnOptionAvailableSelector(state),
    offersByTripId: getOffersByTripId(state),
    travelOfferProperties: getTravelOfferProperties(state),
    isCfarEnabled: isCfarEnabledSelector(state),
    isCustomizePageMarketplaceEnabled:
      isCustomizePageMarketplaceEnabledSelector(state),
    isInDisruptionProtectionRebook:
      isInDisruptionProtectionRebookSelector(state),
    flightShopType: flightShopTypeSelector(state),
    hasActiveRefundableFare: hasActiveRefundableFareInFlightShopSelector(state),
    selectedCfarOffer: selectedCfarOfferSelector(state),
    refundableFaresProperties: refundableFaresPropertiesSelector(state),
    credit: getTravelWalletCredit(state),
    corporateTravel: getCorporateTravel(state),
    isCfarMulticityEnabled: isCfarMulticityEnabledSelector(state),
    potentialCrossSellOffers: getPotentialCrossSellOffers(state),
    selectedAccount: getSelectedAccount(state),
    hasTravelFusionFareBrand:
      hasTravelFusionInSelectedTripDetailsSelector(state),
    isChfarExercise:
      flightShopTypeSelector(state) ===
      FlightShopType.CHANGE_FOR_ANY_REASON_EXERCISE,
  };
};

const mapDispatchToProps = {
  populateFlightBookQueryParams,
  setFlightShopProgress,
  setMulticityFlightShopProgress,
  fetchAncillaryOffer,
  batchFetchCfarOffers,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type FlightShopReviewItineraryConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedFlightShopReviewItinerary = connector(
  withRouter(FlightShopReviewItinerary)
);
